import { getTag, getTags, patchTag, TagFilterParams, TagsParams } from '../../api/tags';
import { Tag } from '../../interfaces/api/tag';

export async function fetchTags(params: TagFilterParams): Promise<Tag[]> {
	try {
		return await getTags(params);
	} catch (error) {
		throw error;
	}
}

export async function fetchTag(id: number, params: TagFilterParams): Promise<Tag> {
	try {
		return await getTag(id, params);
	} catch (error) {
		throw error;
	}
}

export async function updateTag(id: number, params: TagsParams): Promise<Tag> {
	try {
		return await patchTag(id, params);
	} catch (error) {
		throw error;
	}
}
